import {
    FETCH_AGENTS_REQUEST,
    FETCH_AGENTS_SUCCESS,
    FETCH_AGENTS_FAILURE,

    UPDATE_AGENT_STATUS_REQUEST,
    UPDATE_AGENT_STATUS_SUCCESS,
    UPDATE_AGENT_STATUS_FAILURE,
} from "./types";

import {
    fetchAllAgents,
    updateAgentStatus,
} from "../../services/agentService";



export const fetchAgentsRequest = () => ({
    type: FETCH_AGENTS_REQUEST,
});

export const fetchAgentsSuccess = (
    agentsData
) => ({
    type: FETCH_AGENTS_SUCCESS,
    payload: agentsData,
});

export const fetchAgentsFailure = (
    error
) => ({
    type: FETCH_AGENTS_FAILURE,
    payload: error,
});


export const updateAgentStatusRequest =
    () => ({
        type:
            UPDATE_AGENT_STATUS_REQUEST,
    });

export const updateAgentStatusSuccess =
    (updatedAgent) => ({
        type:
            UPDATE_AGENT_STATUS_SUCCESS,
        payload:
            updatedAgent,
    });

export const updateAgentStatusFailure =
    (error) => ({
        type:
            UPDATE_AGENT_STATUS_FAILURE,
        payload:
            error,
    });



export const fetchAgentsAction =
    (
        page = 1,
        size = 20,
        filterField = "status",
        filterValue = ""
    ) =>
    async (dispatch) => {

        dispatch(
            fetchAgentsRequest()
        );

        try {

            const response =
                await fetchAllAgents(
                    page,
                    size,
                    filterField,
                    filterValue
                );

            if (response.error) {

                dispatch(
                    fetchAgentsFailure(
                        response.error
                    )
                );

                return {
                    success: false,
                    error:
                        response.error,
                };
            }

            dispatch(
                fetchAgentsSuccess(
                    response.data
                )
            );

            return {
                success: true,
                data:
                    response.data,
            };

        } catch (error) {

            const message =
                error.message ||
                "Failed to fetch Agents";

            dispatch(
                fetchAgentsFailure(
                    message
                )
            );

            return {
                success: false,
                error: message,
            };
        }
    };



export const updateAgentStatusAction =
    (
        agentId,
        newStatus,
        statusReason = null
    ) =>
    async (dispatch) => {

        dispatch(
            updateAgentStatusRequest()
        );

        try {

            const response =
                await updateAgentStatus(
                    agentId,
                    newStatus,
                    statusReason
                );

            if (response.success) {

                dispatch(
                    updateAgentStatusSuccess(
                        response.data
                    )
                );

                return {
                    success: true,
                    data:
                        response.data,
                };
            }

            dispatch(
                updateAgentStatusFailure(
                    response.error
                )
            );

            return {
                success: false,
                error:
                    response.error,
            };

        } catch (error) {

            const errMsg =
                error.message ||
                "Failed to update agent status";

            console.error(
                "updateAgentStatusAction error:",
                errMsg
            );

            dispatch(
                updateAgentStatusFailure(
                    errMsg
                )
            );

            return {
                success: false,
                error: errMsg,
            };
        }
    };